import * as types from "../actions";
const initialState = {
  isUpdate: false,
};

export default function pbhRequestInfoUpdate(state = initialState, action) {
  const response = action.payload;

  switch (action.type) {
    case types.PBH_REQUEST_UPDATE_OPEN:
      return { ...state, isUpdate: true };
    case types.PBH_REQUEST_UPDATE_CLOSE:
      return { ...state, isUpdate: false };
    default:
      return state;
  }
}
